/* jshint esversion: 6 */
/* jshint esversion: 11 */
/* jshint ignore:start */
import { createContext, useEffect, useRef, useState } from "react";
import { ApiBaseUrl, ImgBaseUrl } from "../config";
import secureLocalStorage from "react-secure-storage";

const MyContext = createContext();

const MyProvider = ({ children }) => {
  const [isLoginShow, setIsLoginShow] = useState(false);
  const [isSignUpShow, setIsSignUpShow] = useState(false);
  const [isLogin, setIsLogin] = useState("");
  const [isPayment, setIsPayment] = useState(false);
  const [paymentStatus, setPaymentStatus] = useState("");
  const [patientStatus, setPatientStatus] = useState("");
  const [isShow, setIsShow] = useState(false);
  const [showBox, setshowBox] = useState(false);
  const [isFooter, setIsFooter] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const [activePage, setActivePage] = useState("");
  const [agoraAppId, setAgoraAppId] = useState(
    () => secureLocalStorage.getItem("agora_app_id") || "",
  );
  const [videoCallProvider, setVideoCallProvider] = useState(
    () => secureLocalStorage.getItem("video_call_provider") || "agora",
  );
  const [videoCallConfig, setVideoCallConfig] = useState(() => {
    try {
      const config = secureLocalStorage.getItem("video_call_config");
      return config ? JSON.parse(config) : null;
    } catch {
      return null;
    }
  });
  const [showCall, setShowCall] = useState(false);
  const [mapKey, setMapKey] = useState("");
  const [transactionid, setTransactionId] = useState("");
  const [apiloading, setApiLoading] = useState(false);
  const [selectproduct, setSelectProduct] = useState("");
  const [medicineId, setMedicineId] = useState("");

  const MenuRef = useRef();

  useEffect(() => {
    if (activePage) {
      sessionStorage.setItem("activepage", activePage);
    }
  }, [activePage]);

  const Value = {
    isLoginShow,
    setIsLoginShow,
    isSignUpShow,
    setIsSignUpShow,
    isLogin,
    setIsLogin,
    isPayment,
    setIsPayment,
    paymentStatus,
    setPaymentStatus,
    patientStatus,
    setPatientStatus,
    isShow,
    setIsShow,
    showBox,
    setshowBox,
    isFooter,
    setIsFooter,
    showMenu,
    setShowMenu,
    activePage,
    setActivePage,
    agoraAppId,
    setAgoraAppId,
    videoCallProvider,
    setVideoCallProvider,
    videoCallConfig,
    setVideoCallConfig,
    showCall,
    setShowCall,
    mapKey,
    setMapKey,
    transactionid,
    setTransactionId,
    apiloading,
    setApiLoading,
    selectproduct,
    setSelectProduct,
    medicineId,
    setMedicineId,
    ApiBaseUrl,
    ImgBaseUrl,
    MenuRef,
  };

  return <MyContext.Provider value={Value}>{children}</MyContext.Provider>;
};

export { MyContext, MyProvider };
/* jshint ignore:end */
